import { render } from "./Button.vue?vue&type=template&id=490f3841"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"
script.render = render

export default script